<template>
    <div>
        <div class="form-section-heading">
            {{ trans('clients.headline.client_information') }}
        </div>
        <section class="section">
            <div class="section-row">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('clients.label.name') }}
                    </div>

                    <div class="value">
                        {{ clientFormFields.name }}<br/>
                        {{ clientFormFields.street }}<br/>
                        {{ clientFormFields.zip }} {{ clientFormFields.city }}<br/>
                        {{ clientFormFields.country }}
                    </div>
                </div>

                <div class="section-row__col section-row__col--one-half" v-if="clientFormFields.differingBillingAddress">
                    <div class="label">
                        {{ trans('clients.label.differing_billing_address') }}
                    </div>

                    <div class="value">
                        {{ clientFormFields.billingStreet }}<br/>
                        {{ clientFormFields.billingZip }} {{ clientFormFields.billingCity }}<br/>
                        {{ clientFormFields.billingCountry }}
                    </div>
                </div>
            </div>
        </section>

        <div class="form-section-heading" v-if="clientFormFields.createClientAdmin">
            {{ trans('clients.headline.client_admin_information') }}
        </div>

        <section class="section" v-if="clientFormFields.createClientAdmin">
            <div class="section-row">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('clients.label.firstname') }}
                    </div>

                    <div class="value">
                        {{ clientFormFields.firstname }}
                    </div>
                </div>

                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('clients.label.lastname') }}
                    </div>

                    <div class="value">
                        {{ clientFormFields.lastname }}
                    </div>
                </div>
            </div>
            <div class="section-row">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('clients.label.email') }}
                    </div>

                    <div class="value">
                        {{ clientFormFields.email }}
                    </div>
                </div>
            </div>
        </section>

        <div class="form-section-heading" v-if="clientFormFields.specificUserFields && clientFormFields.specificUserFields.length">
            {{ trans('clients.headline.specific_user_fields') }}
        </div>

        <section class="section">
            <div class="section-row" v-for="(field, index) in clientFormFields.specificUserFields" :key="index">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('clients.label.field_name') }}
                    </div>
                    <div class="value">
                        {{ field.name }}
                    </div>
                </div>
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('clients.label.required_field') }}
                    </div>
                    <div class="value">
                        {{ field.required == 'true' ? trans('form.yes') : trans('form.no') }}
                    </div>
                </div>
            </div>
        </section>

        <div class="form-section-heading">
            {{ trans('clients.headline.additional_settings') }}
        </div>

        <section class="section">
            <div class="section-row">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('clients.label.access_subclient') }}
                    </div>

                    <div class="value">
                        {{ clientFormFields.accessSubclient ? trans('form.yes') : trans('form.no') }}
                    </div>
                </div>

                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('clients.label.user_deletion_interval') }}
                    </div>

                    <div class="value">
                        {{ clientFormFields.userDeletionInterval }}
                    </div>
                </div>
            </div>
            <div class="section-row">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('clients.label.overdue_delay') }}
                    </div>

                    <div class="value">
                        {{ clientFormFields.overdueDelay }}
                    </div>
                </div>
            </div>
            <div class="section-row">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('clients.label.static_next_assignment') }}
                    </div>

                    <div class="value">
                        {{ clientFormFields.staticNextAssignment ? trans('form.yes') : trans('form.no') }}
                    </div>
                </div>
            </div>
        </section>

        <div class="form-section-heading">
            {{ trans('clients.headline.api_settings') }}
        </div>

        <section class="section">
            <div class="section-row">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('clients.label.api_token_activate') }}
                    </div>

                    <div class="value">
                        {{ clientFormFields.apiToken ? trans('form.yes') : trans('form.no') }}
                    </div>
                </div>
            </div>

            <div class="section-row">
                <div class="section-row__col section-row__col--one-half" v-if="clientFormFields.apiToken">
                    <div class="label">
                        {{ trans('clients.label.api_token') }}
                    </div>

                    <div class="value">
                        {{ clientFormFields.apiToken }}
                    </div>
                </div>
            </div>
        </section>

        <div class="form-section-heading">
            {{ trans('clients.headline.license_settings') }}
        </div>

        <section class="section">
            <div class="section-row">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('clients.label.license_plan') }}
                    </div>

                    <div class="value">
                        {{ trans('clients.label.' + clientLicenseFields.licensePlan) }}
                    </div>
                </div>
            </div>

            <div class="section-row" v-if="clientLicenseFields.licensePlan == 'license_plan_alpha'">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('licenses.label.can_buy_licenses') }}
                    </div>

                    <div class="value">
                        {{ clientLicenseFields.canBuyLicenses ? trans('form.yes') : trans('form.no') }}
                    </div>
                </div>

                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('licenses.label.expiration_period') }}
                    </div>

                    <div class="value">
                        {{ clientLicenseFields.expirationPeriod }}
                    </div>
                </div>
            </div>

            <div class="section-row" v-if="clientLicenseFields.licensePlan == 'license_plan_alpha'">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('licenses.label.amount') }}
                    </div>

                    <div class="value">
                        {{ clientLicenseFields.licenseAmount }}
                    </div>
                </div>

                <div class="section-row__col section-row__col--one-half" v-if="clientLicenseFields.licenseAmount">
                    <div class="label">
                        {{ trans('bookings.label.repeat_period') }}
                    </div>

                    <div class="value" v-if="clientLicenseFields.repeat">
                        {{ clientLicenseFields.repeatPeriod }}
                    </div>

                    <div class="value" v-else>
                        {{ trans('licenses.label.none') }}
                    </div>
                </div>
            </div>

            <div class="section-row" v-if="clientLicenseFields.licensePlan == 'license_plan_beta'">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('licenses.label.accounting_period') }}
                    </div>

                    <div class="value" v-if="clientLicenseFields.accountingPeriod == 1">
                        {{ trans('licenses.label.monthly') }}
                    </div>
                    <div class="value" v-if="clientLicenseFields.accountingPeriod == 3">
                        {{ trans('licenses.label.quarterly') }}
                    </div>
                </div>

                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('licenses.label.accounting_email') }}
                    </div>

                    <div class="value">
                        {{ clientLicenseFields.accountingEmail }}
                    </div>
                </div>
            </div>
        </section>

        <div class="form-section-heading" v-if="clientCourseFields.length">
            {{ trans('courses.label.courses') }}
        </div>

        <section class="section">
            <div class="section-row" v-for="(course, index) in clientCourseFields" :key="index">
                <div class="section-row__col section-row__col--one-half" >
                    <div class="value" v-if="course.course">
                        {{ course.course.label }}
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    props: [
        'clientFormFields',
        'clientLicenseFields',
        'clientCourseFields',
    ],

    methods: {
    },
}
</script>
